<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>运单管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>签收异常列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="item-label">运单编号</span>
        <el-input v-model.trim="filter.orderNumber" style="width: 240px" placeholder="请输入运单编号"> </el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="item-label">司机电话</span>
        <el-input v-model.trim="filter.driverPhone" style="width: 240px" placeholder="请输入司机电话"> </el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="item-label">车牌号</span>
        <el-input v-model.trim="filter.plateNumber" style="width: 240px" placeholder="请输入车牌号"> </el-input>
      </div>

      <div class="toolbar-item" id="auto-3">
        <span class="item-label">线路</span>
        <el-input
          v-model.trim="filter.loadingName"
          style="width: 240px"
          :maxlength="addressKeywordLimit"
          placeholder="发货地"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-4">
        <el-input
          v-model.trim="filter.unloadingName"
          style="width: 240px"
          :maxlength="addressKeywordLimit"
          placeholder="卸货地"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-5">
        <span class="item-label">下单时间</span>
        <el-date-picker
          v-model="timeRange"
          :editable="false"
          @change="chioceTime"
          value-format="timestamp"
          type="datetimerange"
          placeholder="选择日期范围"
          clearable
          :default-time="[' 00:00:00', '23:59:59']"
          style="width: 390px"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="screen" id="auto-6">筛选</el-button>
        <el-button size="small" @click="resetSearch" id="auto-7">清除条件</el-button>
      </div>
    </div>
    <div class="table-custom-box mt-10" id="auto-8">
      <el-table :data="tableData.data" border>
        <el-table-column label="操作" min-width="120" align="center">
          <template v-slot="scope">
            <el-button
              type="text"
              class="font-size12 font-blue"
              v-if="scope.row.poundUrl && scope.row.poundUrl.length"
              @click="showViewer(scope.row.poundUrl)"
              >查看照片</el-button
            >
            <el-button type="text" class="font-size12 font-blue" @click="handleRemark(scope.row)">备注</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="exceptionType" label="异常类型" min-width="100"> </el-table-column>
        <el-table-column prop="orderStatus" label="运单状态" min-width="100"> </el-table-column>
        <el-table-column prop="orderNumber" label="运单号" min-width="160">
          <template v-slot="scope">
            <span class="font-green pointer" @click="showDetail(scope.row)">{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="driverPlateNumber" label="司机车牌号" min-width="100"> </el-table-column>
        <el-table-column prop="driverName" label="司机姓名" min-width="100"> </el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" min-width="100"> </el-table-column>
        <el-table-column prop="loadAddressName" label="装货地址名称" min-width="100"> </el-table-column>
        <el-table-column prop="unloadAddressName" label="卸货地址名称" min-width="100"> </el-table-column>
        <el-table-column prop="orderCreateTime" label="下单时间" min-width="120"> </el-table-column>
        <el-table-column prop="unloadTime" label="卸货时间" min-width="120"> </el-table-column>
        <el-table-column prop="orderSignTime" label="签收时间" min-width="120"> </el-table-column>
        <el-table-column prop="signName" label="收单员" min-width="100"> </el-table-column>
        <el-table-column prop="signPhone" label="收单员手机号" min-width="100"> </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <el-dialog title="备注" :visible="dialogVisible" width="400px" @close="dialogVisible = false">
      <el-input
        style="width: 300px"
        type="textarea"
        v-model.trim="memo"
        placeholder="请输入备注"
        :maxlength="32"
      ></el-input>
      <template #footer>
        <el-button @click="handleConfirm" type="primary" :disabled="!memo">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:8
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/order.new.api';
export default {
  data: function () {
    return {
      timeRange: [],
      pageSize: 20,
      currentPage: 1,
      filter: {
        orderStartTime: null,
        orderEndTime: null,
        orderNumber: '',
        driverPhone: '',
        plateNumber: '',
        loadingName: '',
        unloadingName: ''
      },
      cache: {},
      tableData: { data: [], total: 0 },
      dialogVisible: false,
      memo: '',
      itemNow: {}
    };
  },
  created() {
    this.screen();
  },
  methods: {
    chioceTime(val) {
      if (val) {
        this.filter.orderStartTime = new Date(val[0]).getTime();
        this.filter.orderEndTime = new Date(val[1]).getTime();
      } else {
        this.filter.orderStartTime = null;
        this.filter.orderEndTime = null;
      }
    },
    resetSearch() {
      this.filter.orderStartTime = null;
      this.filter.orderEndTime = null;
      this.timeRange = [];
      this.filter.orderNumber = '';
      this.filter.driverPhone = '';
      this.filter.plateNumber = '';
      this.filter.loadingName = '';
      this.filter.unloadingName = '';
    },
    //筛选查询
    screen() {
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.axiosRequest();
    },
    //分页点击
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    showDetail(row) {
      window.open(`./orderdetail.html#/${row.orderNumber}`);
    },
    axiosRequest() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.cache
      };
      axios.post(api.signExceptionList, options).then(res => {
        if (res.data.total == 0) {
          this.$message.warning('未查询到符合条件的数据');
        }
        this.tableData.data = res.data.data || [];
        this.tableData.total = res.data.total;
      });
    },
    showViewer(poundUrl) {
      const arr = poundUrl.map(el => {
        return { url: el };
      });
      this.$store.dispatch('showViewer', { data: arr });
    },
    handleRemark(row) {
      this.memo = '';
      this.itemNow = row;
      this.dialogVisible = true;
    },
    handleConfirm() {
      axios.post(api.signExceptionRemark, { memo: this.memo, orderNumber: this.itemNow.orderNumber }).then(res => {
        this.dialogVisible = false;
        this.screen();
      });
    }
  }
};
</script>
